module.exports = __webpack_public_path__ + "img/x-close.92f3e2e6.svg";